const state = {
    procesando: false,
    height: 0,
    width: 0,
};

const mutations = {
    'SHOW_SPINNER'(state, params) {
        state.procesando = true;
        state.height = params.height;
        state.width = params.width;
    },
    'HIDE_SPINNER'(state) {
        state.procesando = false;
        state.height = 0;
        state.width = 0;
    },
};

const getters = {
    procesando (state) {
        return state.procesando;
    },
    height (state) {
        return state.height;
    },
    width (state) {
        return state.width;
    },
};

const actions = {
    // procesando ( { commit, state }, params ) {
    //     if (state.procesando) {
    //         commit('HIDE_SPINNER');
    //     } else {
    //         commit('SHOW_SPINNER', params);
    //     }
    // },    
    show ( { commit }, params ) {
        commit('SHOW_SPINNER', params);
    },    
    hide ( { commit } ) {
        commit('HIDE_SPINNER');
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}